// test
import Address from '@/components/structures/address'

/* class Building {
  constructor () {
    this.id = 35645
    this.builder = null
    this.district_custom = 96
    this.subdistrict = null
    this.building_material = 13
    this.build_year = null
    this.building_type = 31
    this.total_floors = null
    this.is_verified = 1
    this.apartment_complex = null
    this.created_at = 1582194548
    this.description_service = null
    this.is_ready = 0
    this.mainBuildingAddress = new Address()
    this.buildingAddresses = [new Address()]
    this.buildingImages = []
  }
} */

class Building {
  constructor () {
    this.id = null
    this.builder = null
    this.district_custom = null
    this.district_official = null
    this.building_material = null
    this.build_year = null
    this.building_type = null
    this.total_floors = null
    this.subdistrict = null
    this.total_apartments = null
    this.building_serial = null
    this.front_doors_count = null
    this.overhaul = null
    this.apartment_complex = null
    this.manager_company = null
    this.description_service = null
    this.description_entrance = null
    this.is_verified = false
    this.is_ready = true
    this.mainBuildingAddress = new Address()
    this.buildingAddresses = [new Address()]
    this.buildingImages = []
    this.mainBuildingImage = null
    this.created_at = Math.floor(Date.now() / 1000)
  }
}

export default Building
